


window.registerGlobal = function(name) {
    window[name] = window[name] || {};
    return window[name];
}

var appName = "MagicCasino";
var appMode = MODE;

registerGlobal('EmInfo');
EmInfo.appName = appName;
EmInfo.appMode = appMode;
EmInfo.appBinarySize = EMS_OUTPUT_SIZE_BINARY;
EmInfo.appBinaryFileSizeGzipped = EMS_OUTPUT_SIZE_BINARY_GZIPPED;
EmInfo.appDataSize = EMS_OUTPUT_SIZE_DATA;
EmInfo.appBinaryFormat = "wasm";

registerGlobal( 'ServerOverride' ); ServerOverride.url = '://game-ws.huuugecasino.net:1033';registerGlobal( 'EmscriptenFacebook' ); EmscriptenFacebook.preRunFbid = '1672695549623058';registerGlobal( 'EmscriptenDeepLink' ); EmscriptenDeepLink.apiKey = 'key_live_gpb1C2lEo21HgJTBcV0zQenauvpyesA5';


//////////////////
// WEBPACK FOOTER
// ./js/Application.initializers.js
// module id = 9
// module chunks = 0